// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__3p4Wg"};